module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('span', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("Salary Details")]), _vm._v(" "), _c('Datatable', {
    attrs: {
      "value": _vm.payHeadList
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "PayHead",
      "field": ""
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Amount",
      "field": "value"
    }
  })], 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Save",
      "icon": "pi pi-save"
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("Bank Detail")]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "bankName"
    }
  }, [_vm._v("Bank Name")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "bankName"
    },
    model: {
      value: (_vm.bankName),
      callback: function($$v) {
        _vm.bankName = $$v
      },
      expression: "bankName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "accountNumber"
    }
  }, [_vm._v("Account Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "accountNumber"
    },
    model: {
      value: (_vm.accountNumber),
      callback: function($$v) {
        _vm.accountNumber = $$v
      },
      expression: "accountNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "branch"
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Save",
      "icon": "pi pi-save"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bff85d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Employee/salary.vue
// module id = 2339
// module chunks = 0